"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Header_1 = tslib_1.__importDefault(require("../../../view/components/Header"));
var Text_1 = tslib_1.__importDefault(require("./Text"));
var WidgetFormattedText = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b;
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        data.header && react_1["default"].createElement(Header_1["default"], null, data.header),
        data.text && react_1["default"].createElement(Text_1["default"], { text: data.text })));
};
exports["default"] = react_1["default"].memo(WidgetFormattedText);
